import CallServer from '../../api/CallServerV2';
export async function fetchImpersonateUser(tenant, user_id) {
    return await CallServer({
        endpoint: '/impersonate_user',
        params: {
            tenant: tenant,
            user_id: user_id
        },
        withoutTenant: true,
        retryIfFailed: true
    })
}

export async function fetchSubjects(params = {}) {
    return await CallServer({
        params: params,
        endpoint: '/admin/get_subjects',
        isGet: true,
    })
}

export async function fetchAddSubject(subject_data) {
    return await CallServer({
        endpoint: '/admin/add_new_subject',
        params: subject_data,
    })
}

export async function fetchEditSubject(subject_data) {
    return await CallServer({
        endpoint: '/admin/edit_subject',
        params: subject_data,
    })
}

export async function fetchOfaSettings(params = {}) {
    return await CallServer({
        params: params,
        endpoint: '/admin/get_ofa_settings',
        isGet: true,
    })
}

export async function fetchUpdateOfaSettings(settings_data) {
    return await CallServer({
        endpoint: '/admin/update_ofa_settings',
        body: settings_data,
    })
}